import { GET_CALL_SCHEDULE_TYPE_IDS, GET_CALL_SCHEDULE_TYPE_FILTER, UPDATE_CALL_SCHEDULE_TYPE_FILTER } from "../constants/action-types";
  
  import Axios from "axios";
  
  import { getApiConfig } from "../../config/apiConfig";
  import { adalApiFetch } from "../../config/azureConfig";
  const API_CONFIG = getApiConfig();
  
  
  /* 
    Get call schedule type ids.
  */
  export const getCallScheduleTypeIds = (callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/callSchedule/typeIds`, {
      method: "get"
    }).then(res => {
      const data = res.data;
  
      dispatch({
        type: GET_CALL_SCHEDULE_TYPE_IDS,
        payload: data
      });
  
      callback(true);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    })
  };
  
  /* 
    Get call schedule type filter.
  */
  export const getCallScheduleTypeFilter = (callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/callSchedule/filterConfiguration`, {
      method: "get"
    }).then(res => {
      const data = res.data;
  
      dispatch({
        type: GET_CALL_SCHEDULE_TYPE_FILTER,
        payload: data
      });
  
      callback(true);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    })
  };
  
  /*
    Update call schedule call filter
  */
  export const postCallScheduleTypeFilter = (data, callback) => dispatch => {
    
    const CallScheduleTypeFilter = {
        "CallScheduleTypeFilter": data
    }

    adalApiFetch(Axios, `${API_CONFIG.URL}/callSchedule/filterConfiguration`, {
      method: "post",
      data: CallScheduleTypeFilter
    }).then(res => {
    //   const id = res.data;
        
      dispatch({
        type: UPDATE_CALL_SCHEDULE_TYPE_FILTER,
        payload: res.data
      });
  
      callback(true);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    })
  }